import { IVoucherHolderForList } from '@nkr/models/index';
import { AdminGridWrapper } from './styles';
import { GridReadyEvent } from 'ag-grid-community';
import CommonList from './common-list';

interface IProps {
    centerId: number,
    list: IVoucherHolderForList[],
    isLoading: boolean,
    onOrderBuccalSwabKit: (id: number) => void,
    onOrderLabScreening: (id: number) => void,
    onReorderLabScreening: (id: number) => void,
    onUploadVoucherConsent: (id: number) => void,
    onUploadSwabResults: (id: number) => void,
    onUploadScreeningResults: (id: number) => void,
    onResendLink: (id: number) => void,
    onDownload: (voucherHolderId: number, docType: number) => void
    onLoadingComplete: () => void,
    onGridReady: (e: GridReadyEvent) => void
}

const AdminVoucherHolderList = (props: IProps) => {
    return (
        <AdminGridWrapper className='ag-theme-bootstrap'>
            <CommonList
                list={props.list}
                centerId={props.centerId}
                isAdmin={true}
                isAdminLogin={true}
                isLoading={props.isLoading}
                groupByDonor={true}
                onOrderBuccalSwabKit={props.onOrderBuccalSwabKit}
                onOrderLabScreening={props.onOrderLabScreening}
                onReorderLabScreening={props.onReorderLabScreening}
                onUploadVoucherConsent={props.onUploadVoucherConsent}
                onUploadSwabResults={props.onUploadSwabResults}
                onUploadScreeningResults={props.onUploadScreeningResults}
                onResendLink={props.onResendLink}
                onDownload={props.onDownload}
                onLoadingComplete={props.onLoadingComplete}
                onGridReady={props.onGridReady}
            />
        </AdminGridWrapper>
    );
}

export default AdminVoucherHolderList;